import { useState } from "react";
import { connect } from "react-redux";
import Button from "@shared/v2/Button/Button";
import Alert from "@shared/v2/Alert";
import Check from "@shared/v2/Icomoon/Icons/Check";
import { ImportListingDetailsModal } from "../ImportListingDetailsModal";
import * as thunkActions from "../actions/thunks";

const ImportListingDetailsBtn = ({
  accountPropertyTypes,
  listingDetailsData,
  uuid,
  photosAvailable,
  propertyDetails,
  importDetailAsThunk,
}) => {
  const [showModal, setshowModal] = useState(false);
  const [showAlert, setshowAlert] = useState(false);

  const closeModal = () => {
    setshowModal(false);
  };

  const openModal = () => {
    setshowModal(true);
  };

  const handleImportSuccess = () => {
    closeModal();
  };

  return (
    <>
      {showAlert && (
        <Alert
          variant="success"
          containerClass="tw-z-10 !tw-top-0 !tw-absolute !tw-right-2/5 !tw-left-2/5"
          text={
            <>
              <Check size="xl" className="tw-w-16px tw-h-16px tw-mb-[-4px]" />
              <span className="tw-pl-[9px]">Listing details imported from MLS</span>
            </>
          }
          role="alert"
        />
      )}

      <div className="tw-ml-auto">
        <Button schema="secondary" size="small" onClick={openModal}>
          Import Listing Details
        </Button>
      </div>
      <ImportListingDetailsModal
        modalOpen={showModal}
        closeModal={closeModal}
        isFromDetail
        accountPropertyTypes={accountPropertyTypes}
        listingDetailsData={listingDetailsData}
        uuid={uuid}
        photosAvailable={photosAvailable}
        title="Import Listing Details"
        propertyDetails={propertyDetails}
        importDetailAsThunk={(userUUID, payload, onComplete) =>
          importDetailAsThunk(userUUID, payload, setshowAlert, handleImportSuccess, onComplete)
        }
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  accountPropertyTypes: state.tdpDetailsReducer.meta.accountPropertyTypes,
  listingDetailsData: state.tdpDetailsReducer.listingDetails,
  uuid: state.tdpDetailsReducer.uuid,
  photosAvailable: state.tdpDetailsReducer.listingImgs.length,
  propertyDetails: state.tdpDetailsReducer.propertyDetails,
});

const mapDispatchToProps = (dispatch) => ({
  importDetailAsThunk: (uuid, payload, setshowAlert, onSuccess, onComplete) =>
    dispatch(thunkActions.importDetailAsThunk(uuid, payload, setshowAlert, onSuccess, onComplete)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportListingDetailsBtn);
